<script lang="tsx" setup>
import useAssetColumns from './columns'
import FilterContainer from '../filter/FilterContainer.vue'
import TextFilter from '../filter/TextFilter.vue'
import ResponsibleFilter from '../filter/ResponsibleFilter.vue'
import InstanceFilter from '../filter/InstanceFilter.vue'
import { TextField, ValueField } from '@/models/select-item'
import { useI18n } from 'vue-i18n'
import MultiSelectFilter from '../filter/MultiSelectFilter.vue'
import { getActiveText } from '@/services/utils'
import { computed, onBeforeMount } from 'vue'
import useSubAssetColumns from '../sub_asset/columns'
import type { ColumnGroup } from '../filter/shared'

const props = defineProps({
	component: { type: String, required: true },
	bookmark: { default: 'assets-bookmark', required: false },
	icon: { type: String },
})

const { columns, all } = useAssetColumns(props.component)
const sub = useSubAssetColumns('sub_' + props.component)
const { t } = useI18n()
const isKeyOfColumns = (key: string): key is keyof typeof columns => key in columns

const setFilterFromParams = () => {
	const params = new URLSearchParams(window.location.search)
	for (const [key, value] of params) {
		// Key doesn't exist in columns or not a filter param.
		if (!isKeyOfColumns(key)) {
			continue
		}
		const column = columns[key].value
		if (key === 'responsible') {
			const parsed = JSON.parse(value)
			column.filter = [{ id: parsed.id, type: parsed.type }]
		} else if (key === 'name') {
			column.filter = value
		} else {
			const parsedNumber = parseInt(value)
			if (!isNaN(parsedNumber)) {
				column.filter.push(parsedNumber)
			} else {
				column.filter.push(value)
			}
		}
	}
}

onBeforeMount(() => {
	setFilterFromParams()
})

const colGroups = computed<ColumnGroup[]>(() => [
	{
		title: t('asset.sub', 2),
		columns: sub.all.value,
	},
])
</script>

<template>
	<FilterContainer :columns="all" :groups="colGroups" :bookmark="props.bookmark" :icon="props.icon">
		<div class="p-2 filter-col" v-if="columns.inventoryNr.value.isVisible">
			<TextFilter id="inventory-nr-filter-asset" v-model="columns.inventoryNr.value"></TextFilter>
		</div>

		<div class="p-2 filter-col" v-if="columns.name.value.isVisible">
			<TextFilter id="name-filter-asset" v-model="columns.name.value"></TextFilter>
		</div>

		<div class="p-2 filter-col" v-show="columns.instance.value.isVisible">
			<InstanceFilter id="instance-filter-asset" v-model="columns.instance.value"></InstanceFilter>
		</div>

		<div class="p-2 filter-col" v-if="columns.location.value.isVisible">
			<TextFilter id="location-filter-asset" v-model="columns.location.value"></TextFilter>
		</div>

		<div class="p-2 filter-col" v-if="columns.responsible.value.isVisible">
			<ResponsibleFilter id="responsible-filter-asset" v-model="columns.responsible.value"></ResponsibleFilter>
		</div>

		<div class="p-2 filter-col" v-if="columns.status.value.isVisible">
			<MultiSelectFilter
				v-model="columns.status.value"
				:label-field="TextField"
				:value-field="ValueField"
				:formatter="getActiveText"
				:options="[
					{ text: t('asset.status.active'), value: 1 },
					{ text: t('asset.status.notActive'), value: 0 },
				]"
			></MultiSelectFilter>
		</div>
	</FilterContainer>
</template>
